import { SocietyCode } from '../stepper/stepper.model';
import { NoValue } from '@tribeauto/ngx-mobilite-material';

export const isCreditModerne = (societyCode: SocietyCode | NoValue): boolean => {
  return !!societyCode && [SocietyCode.CMAG, SocietyCode.CMOI].includes(societyCode as SocietyCode);
};
